import * as Yup from 'yup'

const CmsBlogPostFormSchema = Yup.object().shape({
  title: Yup.string()
    .required('Required')
})

export default CmsBlogPostFormSchema
